import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from './../videos/CloudfrontVideoFormat';
import './Learn.css';
import SlideShow from './Slideshow';
import { Buffer } from 'buffer';
import Ballonlearn from "../Unit4/Module16/Ballon/BallonLearn"
import Kitelearn from "../Unit4/Module17/Kite/KiteLearn"
import Egglearn from "../Unit4/Module18/Egg/EggLearn"
import Cottonlearn from "../Unit4/Module19/Cotton/CottonLearn"
import Applelearn from "../Unit4/Module20/Apple/AppleLearn"
import ReactPlayer from "react-player";
window.Buffer = Buffer;

/**
 * Plays the learn video shown at the start of each day.
 */
export default function Learn(props) {
  // Sets up the initial variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [, forceUpdate] = useState();
  const [displayLearnVideo, setDisplayLearnVideo] = useState(!!props.video);
  const [displaySlideShow, setDisplaySlideShow] = useState(false);
  const [displayVideoShow, setDisplayVideoShow] = useState(!props.video);
  const [displayClosingVideo, setDisplayClosingVideo] = useState(false);
  const [displayInfluencerVideo, setDisplayInfluencerVideo] = useState(false);
  const [displayballonScene, setDisplayBallonScene] = useState(false);
  const [displayKiteScene, setDisplayKiteScene] = useState(false);
  const [displayEggScene, setDisplayEggScene] = useState(false);
  const [displayCottonScene, setDisplayCottonScene] = useState(false);
  const [displayAppleScene, setDisplayAppleScene] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [audio1Ready, setAudio1Ready] = useState(false);
  const [audio2Ready, setAudio2Ready] = useState(false);
  const [loopOnce, setLoopOnce] = useState(false);
  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };
  const [slideShow, setslideShow] = useState(
    <SlideShow
      navigate={props.destiny}
      slides={props.slides}
      audio={props.song}
      setDisplayLearn={props.setDisplayLearn}
      lyrics={props.lyrics}
      step_completed={props.step_completed}
      module={props.module}
      instrumental={props.instrumental}
    />
  );

  const Exit = login.cloudFront + 'images/Images/close.png' + login.cookie;
  const recordPlayer = useRef();
  const instrumentalPlayer = useRef();
  const playerRef = useRef(null);
  const lastVideoTimeRef = useRef(0);
  const lastCorrectionMsRef = useRef(0);
  const isIOS = typeof navigator !== 'undefined' && ((/iPad|iPhone|iPod/.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  const DRIFT_THRESHOLD_SECONDS = isIOS ? 0.6 : 0.2;
  const DRIFT_CORRECTION_MIN_INTERVAL_MS = isIOS ? 1500 : 250;
  const [controls, setControls] = useState(isIOS ? true : (!window.location.href.includes('wearefriends.cool')) ?  true : window.location.href.includes('staging') ? true : false);

  // Always-mounted iOS-safe audio control
  const songAudioRef = useRef(null);
  const instrumentalAudioRef = useRef(null);
  const expectedSongSrcRef = useRef('');
  const expectedInstrumentalSrcRef = useRef('');
  const [songSrc, setSongSrc] = useState('');
  const [instrumentalSrc, setInstrumentalSrc] = useState('');
  const [songShouldPlay, setSongShouldPlay] = useState(false);
  const [instrumentalShouldPlay, setInstrumentalShouldPlay] = useState(false);
  const [started, setStarted] = useState(true);
  const playSongAudio = (src, restartIfSame = true) => {
    const el = songAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedSongSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; el.play(); } catch {}
    } else {
      setSongSrc(src);
      setSongShouldPlay(true);
    }
  };
  const playInstrumentalAudio = (src, restartIfSame = true) => {
    const el = instrumentalAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedInstrumentalSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; el.play(); } catch {}
    } else {
      setInstrumentalSrc(src);
      setInstrumentalShouldPlay(true);
    }
  };

  // Determines whether to play the audio containing the regular song or the song with the child&apos;svocals
  useEffect(() => {
    if (props.song) {
      setAudio1Ready(true);
    }
    if (props.instrumental) {
      setAudio2Ready(true);
    }
  }, []);

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  useEffect(() => {
    return () => {
      try {
        if (songAudioRef.current) songAudioRef.current.pause();
      } catch {}
      try {
        if (instrumentalAudioRef.current) instrumentalAudioRef.current.pause();
      } catch {}
    };
  }, []);


  // Shows the actual video displayed in the center of the screen with the world background behind it.
  const DisplayLearn = () => {
    return (
      <div
        className='learnBody'
        id='slideshow-wrapper'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayLearn(false);
          }}
        ></img>
        {displayLearnVideo && (
          <CloudfrontVideoFormat
            source={props.video}
            back={props.back}
            background={props.background}
            close={props.setDisplayLearn}
            ended={() => {
              if (props.slides) {
                setDisplaySlideShow(true);
                setDisplayLearnVideo(false);
              } else {
                setDisplayLearnVideo(false);
                setDisplayVideoShow(true);
              }
            }}
          />
        )}
        {displaySlideShow && slideShow}


        {displayVideoShow && (
          <>
            {/* audio elements moved to always-mounted area */}
            <ReactPlayer
              ref={playerRef}
              controls={controls}
              className="learnVideo"
              playing={true}
              onPlay={() => {
                const t = lastVideoTimeRef.current || 0;
                if (audio1Ready && props.song) {
                  const el = songAudioRef.current;
                  if (el) { el.currentTime = t; el.volume = 1; }
                  playSongAudio(props.song);
                }
                if (audio2Ready && props.instrumental) {
                  const el2 = instrumentalAudioRef.current;
                  if (el2) { el2.currentTime = t; el2.volume = 0.6; }
                  playInstrumentalAudio(props.instrumental);
                }
              }}
              onPause={() => {
                try { if (songAudioRef.current) songAudioRef.current.pause(); } catch {}
                try { if (instrumentalAudioRef.current) instrumentalAudioRef.current.pause(); } catch {}
              }}
              onProgress={({ playedSeconds }) => {
                lastVideoTimeRef.current = playedSeconds;
                const syncTo = playedSeconds;
                const now = Date.now();
                if (now - lastCorrectionMsRef.current < DRIFT_CORRECTION_MIN_INTERVAL_MS) return;
                let corrected = false;
                if (songAudioRef.current) {
                  const diff = songAudioRef.current.currentTime - syncTo;
                  if (Math.abs(diff) > DRIFT_THRESHOLD_SECONDS) {
                    if (isIOS) {
                      if (diff < -DRIFT_THRESHOLD_SECONDS) {
                        songAudioRef.current.currentTime = syncTo - 0.05;
                        corrected = true;
                      }
                    } else {
                      songAudioRef.current.currentTime = syncTo;
                      corrected = true;
                    }
                  }
                }
                if (instrumentalAudioRef.current) {
                  const diff2 = instrumentalAudioRef.current.currentTime - syncTo;
                  if (Math.abs(diff2) > DRIFT_THRESHOLD_SECONDS) {
                    if (isIOS) {
                      if (diff2 < -DRIFT_THRESHOLD_SECONDS) {
                        instrumentalAudioRef.current.currentTime = syncTo - 0.05;
                        corrected = true;
                      }
                    } else {
                      instrumentalAudioRef.current.currentTime = syncTo;
                      corrected = true;
                    }
                  }
                }
                if (corrected) lastCorrectionMsRef.current = now;
              }}
              onSeek={(seconds) => {
                if (songAudioRef.current) songAudioRef.current.currentTime = seconds;
                if (instrumentalAudioRef.current) instrumentalAudioRef.current.currentTime = seconds;
              }}
              url={props.songVideo}
              onEnded={() => {
                try {
                  if (songAudioRef.current) {
                    songAudioRef.current.pause();
                    songAudioRef.current.currentTime = 0;
                    songAudioRef.current.removeAttribute('src');
                    songAudioRef.current.load();
                  }
                } catch {}
                try {
                  if (instrumentalAudioRef.current) {
                    instrumentalAudioRef.current.pause();
                    instrumentalAudioRef.current.currentTime = 0;
                    instrumentalAudioRef.current.removeAttribute('src');
                    instrumentalAudioRef.current.load();
                  }
                } catch {}
                if (props.closingVideo) {
                  setDisplayVideoShow(false);
                  setDisplayClosingVideo(true);
                } else {
                  setDisplayVideoShow(false);
                  setDisplayInfluencerVideo(true);
                }
              }}
              playsinline={true}
            />
          </>
        )}
        
        {displayClosingVideo && 
          <CloudfrontVideoFormat source={props.closingVideo} back={props.back} background={props.background} close={props.setDisplayLearn} ended={() => {
            if(props.module16){
              setDisplayBallonScene(true)
            }
            else if (props.module17){
              setDisplayKiteScene(true)
            }
            else if (props.module18){
              setDisplayEggScene(true)
            }
            else if (props.module19){
              setDisplayCottonScene(true)
            }
            else if (props.module20){
              setDisplayAppleScene(true)
            }
            else{
              if(props.module.reviewIcon === false){
                  dispatch({ type: props.step_completed, payload: "learn"});
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayLearn(false)
            }
          }}/>
        }

        {displayInfluencerVideo && (
            <div id='influencerVideo'>
              <video
              style={videoPlayer}
              autoPlay
              playsInline
              controls={isIOS ? started : false}
              onPlaying={() => {
                setStarted(false);
              }}
              onEnded={() => {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayLearn(false);
              }}
              onError={() => {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.setDisplayLearn(false);
              }}
            >
              <source src={props.influencerVideo} type='video/mp4'></source>
            </video>
          </div>
        )}

      </div>
    );
  };

      // The actual HTML code telling the world module to show the learn video
      return (
        <>
            {!displayAppleScene && !displayCottonScene && !displayEggScene && !displayballonScene && !displayKiteScene && DisplayLearn()}
            {/* Always-mounted audio elements for iOS-safe playback */}
            <audio
              ref={songAudioRef}
              src={songSrc}
              preload='auto'
              playsInline
              onLoadedData={() => {
                const el = songAudioRef.current;
                if (!el) return;
                const expected = expectedSongSrcRef.current;
                const currentSrc = el.currentSrc || el.src;
                if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
                if (!songShouldPlay) return;
                try { el.currentTime = el.currentTime || 0; el.play(); } catch {}
              }}
              onEnded={() => {
                // handle module7 loop once behavior
                if (
                  props.step_completed === 'MODULE7_SET_stepCompleted' &&
                  !loopOnce &&
                  props.module.currentday > 3
                ) {
                  setTimeout(() => {
                    try { songAudioRef.current && songAudioRef.current.play(); } catch {}
                    setLoopOnce(true);
                  }, 2500);
                }
                setSongShouldPlay(false);
              }}
            />
            <audio
              ref={instrumentalAudioRef}
              src={instrumentalSrc}
              preload='auto'
              playsInline
              onLoadedData={() => {
                const el = instrumentalAudioRef.current;
                if (!el) return;
                const expected = expectedInstrumentalSrcRef.current;
                const currentSrc = el.currentSrc || el.src;
                if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
                if (!instrumentalShouldPlay) return;
                try { el.currentTime = el.currentTime || 0; el.play(); } catch {}
              }}
              onEnded={() => { setInstrumentalShouldPlay(false); }}
            />
            {displayballonScene && <Ballonlearn background={props.background} animal={props.animal} setDisplayLearn={props.setDisplayLearn} 
            learnVideo1={props.learnVideo1} learnVideo2={props.learnVideo2} learnVideo3={props.learnVideo3} learnVideo4={props.learnVideo4}
            module={props.module} step_completed ={props.step_completed}/>}
            {displayKiteScene && <Kitelearn background={props.background} animal={props.animal} setDisplayLearn={props.setDisplayLearn} 
            learnVideo1={props.learnVideo1} learnVideo2={props.learnVideo2} learnVideo3={props.learnVideo3} module={props.module} step_completed ={props.step_completed} closingVideo={props.closingVideo}/>}
            {displayEggScene && <Egglearn background={props.background} animal={props.animal} setDisplayLearn={props.setDisplayLearn} 
            learnVideo1={props.learnVideo1} learnVideo2={props.learnVideo2} learnVideo3={props.learnVideo3} module={props.module} step_completed ={props.step_completed} closingVideo={props.closingVideo}/>}
            {displayCottonScene && <Cottonlearn background={props.background} animal={props.animal} setDisplayLearn={props.setDisplayLearn} 
            learnVideo1={props.learnVideo1} learnVideo2={props.learnVideo2} learnVideo3={props.learnVideo3} module={props.module} step_completed ={props.step_completed} closingVideo={props.closingVideo}/>}
            {displayAppleScene && <Applelearn background={props.background} animal={props.animal} setDisplayLearn={props.setDisplayLearn} 
            learnVideo1={props.learnVideo1} learnVideo2={props.learnVideo2} learnVideo3={props.learnVideo3} module={props.module} step_completed ={props.step_completed} closingVideo={props.closingVideo}/>}
        </>
    )
}
